import { render } from "./ArchivedTasksListModal.vue?vue&type=template&id=df737eb2"
import script from "./ArchivedTasksListModal.vue?vue&type=script&lang=js"
export * from "./ArchivedTasksListModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__